module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "channels"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.searchMode && !_vm.editMode),
      expression: "!searchMode && !editMode"
    }],
    staticClass: "channels_actions"
  }, [_c('div', {
    on: {
      "click": _vm.searchOn
    }
  }, [_c('i', {
    staticClass: "icon-magnifier"
  })]), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.editChannelList
    }
  }, [_c('i', {
    staticClass: "icon-pencil"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "channels_search channels_top-bar",
    class: {
      'active': _vm.searchMode
    }
  }, [_c('div', {
    staticClass: "back",
    on: {
      "click": _vm.searchBack
    }
  }, [_c('i', {
    staticClass: "icon-arrow-left"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.search),
      expression: "filters.search"
    }],
    ref: "searchInput",
    attrs: {
      "type": "text",
      "placeholder": "поиск канала"
    },
    domProps: {
      "value": (_vm.filters.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "search", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "channels_edit channels_top-bar",
    class: {
      'active': _vm.editMode
    }
  }, [_c('div', {
    staticClass: "back",
    on: {
      "click": _vm.editBack
    }
  }, [_c('i', {
    staticClass: "icon-arrow-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "edit-text"
  }, [_vm._v("Режим редактирования - чтобы скрыть или показать канал нажмите на иконку справа")])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredChannels.length > 0),
      expression: "filteredChannels.length > 0"
    }],
    attrs: {
      "id": "channels_filtered_ul"
    }
  }, _vm._l((_vm.filteredChannels), function(channel) {
    return _c('Channel', {
      key: channel.id,
      attrs: {
        "channel": channel,
        "editMode": _vm.editMode
      },
      on: {
        "openChannel": _vm.openChannel,
        "apiGetChannelList": _vm.apiGetChannelList
      }
    })
  }), 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredChannels.length === 0),
      expression: "filteredChannels.length === 0"
    }],
    attrs: {
      "id": "channels_ul"
    }
  }, _vm._l((_vm.channels), function(channel) {
    return _c('Channel', {
      key: channel.id,
      attrs: {
        "channel": channel,
        "channelGroupId": _vm.getChannelGroupId(channel),
        "editMode": _vm.editMode
      },
      on: {
        "openChannel": _vm.openChannel,
        "apiGetChannelList": _vm.apiGetChannelList,
        "hideChannel": _vm.hideChannel,
        "showChannel": _vm.showChannel
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-976270b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Channels.vue
// module id = 97
// module chunks = 0